/****************************************************
 * Module Name:  TenderLotBidProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class TenderLotBidProxy {

    static MakeSellBid = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/sell",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static MakeManufacturingBid = (data, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/manufacturing",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetTenderLotPricePlanDataByTenderStoneId = (tenderstoneid, callback) => {
        let params = {
            tenderstoneid: tenderstoneid,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/priceplan",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetTenderLotPricePlanDataByTenderId = (tenderid, isSalesbid, callback) => {
        let params = {
            tenderid: tenderid,
            isSalesbid: isSalesbid,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/priceplan/bytenderid",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetTenderLotPricePlanDataByTenderStoneIdAndStatus = (tenderstoneid, bidstatus, planstatus, callback) => {
        let params = {
            tenderstoneid: tenderstoneid,
            bidstatus: bidstatus,
            planstatus: planstatus,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/priceplan/bystatus",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetTenderLotPricePlanDataByTenderStoneidAndStatusPreview = (tenderstoneid, bidstatus, planstatus, callback) => {
        let params = {
            tenderstoneid: tenderstoneid,
            bidstatus: bidstatus,
            planstatus: planstatus
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/priceplan/bystatus/preview",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static LockStoneWiseBid = (data, callback) => {

        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/stone/lockbid",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static LockLotWiseBid = (data, callback) => {

        restAPICall(
            Constants.MANAGER_URL + "/tenderlotbid/lot/lockbid",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(data),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


    static GetTenderPlansByStoneID = (tenderstoneid, tenderlotId, callback) => {
        let params = {
            tenderlotid: tenderlotId,
            tenderstoneid: tenderstoneid,
        }
        restAPICall(
            Constants.MANAGER_URL + "/tenderstone/plan",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };
}